import styled from "styled-components";
import theme from "../../styles/theme.css";

export const ContainerHD = styled.nav`
  height: ${theme.headerHeight};
  /* max-width: 100vw; */
  width: 100%;
  box-sizing: border-box;
  background-color: ${theme.black};
  z-index: 10;
  position: fixed;
  top: 0;
  display: grid;
  grid-template-areas: "area1 area3 area4";
  padding: 1px 1rem;
  grid-gap: 1rem;
  a,
  span {
  }
  .item1 {
    grid-area: area1;
    display: grid;
    align-items: center;
    justify-content: flex-start;
    img {
      margin: auto;
      max-width: 140px;
    }
  }
  .item3 {
    grid-area: area3;
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    margin-right: -8%;
    overflow: hidden;
    @media (orientation: portrait) {
      margin-right: -30px;
    }
    > a {
      img {
        max-height: calc(${theme.headerHeight} - 40px);
      }
    }

    .sponsor {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      margin-top: -9px;
      align-items: center;
      color: white;
      font-family: "Helvetica Neue", Arial, sans-serif;
      font-size: 8px;
      text-transform: uppercase;
      align-items: center;
      justify-content: center;

      text-align: center;
      span {
        text-align: right;
        letter-spacing: -0.05em;
      }
      img {
        max-width: 40px;
      }
    }
  }
  .item4 {
    grid-area: area4;
    display: grid;
    align-items: center;
    justify-content: flex-end;
    img {
      margin: auto;
      max-width: 140px;
    }
  }

  @media (max-width: 680px) {
    .item1 img {
      max-width: 80px;
    }
    .item3 a {
      height: 25px;
      img {
        height: 25px;
      }
    }
    .item4 img {
      max-width: 80px;
    }
  }
`;
